import { create } from 'zustand'

import { TabOption } from '@/components/common/Tabs'

export type TabLabelKey = 'unpacking' | 'importing' | 'waiting' | 'fileBrowsing'

interface CustomsState {
  loading: boolean
  tabLabels: TabOption[]
  activeTab: TabLabelKey
}

interface CustomsActions {
  changeTabLabel: (tabKey: TabLabelKey) => void
}

type CustomsStore = CustomsState & CustomsActions

const initialState: CustomsState = {
  loading: false,
  tabLabels: [
    { value: 'importing', label: '数据导入' },
    { value: 'unpacking', label: '拆柜详情' },
    { value: 'waiting', label: '预约搬出' },
    { value: 'fileBrowsing', label: '相关文件' }
  ],
  activeTab: 'unpacking'
}

export const useCustomsStore = create<CustomsStore>()((set) => ({
  ...initialState,
  changeTabLabel: (value) => {
    set({
      activeTab: value
    })
  }
}))

export const useCustomsState = () => {
  const tabLabels = useCustomsStore((state) => state.tabLabels)
  const activeTab = useCustomsStore((state) => state.activeTab)
  return { tabLabels, activeTab }
}

export const useCustomsActions = () => {
  const changeTabLabel = useCustomsStore((state) => state.changeTabLabel)
  return { changeTabLabel }
}
